import React, { useState } from "react";
import { CommunityReviewList } from "./List";
import { CommunityReviewDrawer } from "./Drawer";
import { Box, Divider, Typography } from "@mui/material";

export default function CommunityReviewPage() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  const handleRowClick = ({ row }) => {
    setSelectedReview(row);
    setIsDrawerOpen(true);
  };

  const handleClose = () => {
    setIsDrawerOpen(false);
    setSelectedReview(null);
  };

  return (
    <Box paddingX="32px" display="flex" width="100%" justifyContent="center">
      <Box width="100%" maxWidth="1536px">
        <Typography variant="h4" component="h1" gutterBottom>
          Community Reviews
        </Typography>
        <Divider />

        <CommunityReviewList onRowClick={handleRowClick} />
      </Box>

      {selectedReview && (
        <CommunityReviewDrawer
          review={selectedReview}
          isOpen={isDrawerOpen}
          onClose={handleClose}
        />
      )}
    </Box>
  );
}
